import {
  Box,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import * as React from 'react';
import { useEffect, useState } from 'react';
import request from 'src/utils/request';
import loaderGif from '../common/no_bg_loader.gif';

interface Props {
  showPreview: {
    status: boolean;
    endorsementId: number | null;
    btn_text:string | null
  };
  setShowPreview: Function;
}

const ReshareEndorsementPreview = ({
  showPreview,
  setShowPreview
}: Props) => {
  const [previewLoading, setPreviewLoading] = useState<boolean>(false);
  const [previewHtml, setPreviewHtml] = useState<any>(null);
  const [reshareLoading, setReshareLoading] = useState<boolean>(false);

  useEffect(() => {
    if (showPreview?.status && showPreview?.endorsementId) {
      fetchPreview();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showPreview?.status]);

  const fetchPreview = () => {
    setPreviewLoading(true);
    request({
      url: 'endorsement/reShareEndorsementToInsurer',
      method: 'post',
      data: {
        mailPreview: true,
        endorsementId: showPreview.endorsementId
      }
    }).then(
      (response: any) => {
        setPreviewHtml(response);
        setPreviewLoading(false);
      },
      (error) => {
        console.error(error);
        setPreviewLoading(false);
      }
    );
  };

  const handleReshare = () => {
    setReshareLoading(true);
    request({
      url: 'endorsement/reShareEndorsementToInsurer',
      method: 'post',
      data: {
        mailPreview: false,
        endorsementId: showPreview.endorsementId
      }
    }).then(
      () => {
        setReshareLoading(false);
        setShowPreview({
          status: false,
          endorsementId: null
        });
      },
      (error) => {
        console.error(error);
        setReshareLoading(false);
      }
    );
  };

  return (
    <Dialog
      open={showPreview.status}
      onClose={() =>
        setShowPreview({
          status: false,
          endorsementId: null
        })
      }
      maxWidth="lg"
      fullWidth
      scroll="body"
    >
      <DialogTitle>Reshare Endorsement – Mail Preview</DialogTitle>

      <DialogContent
        sx={{
          p: 0,
          overflow: 'visible'
        }}
      >
        {previewLoading ? (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="center">
                    <img
                      alt="loader"
                      src={loaderGif}
                      width={100}
                      height={100}
                    />
                  </TableCell>
                </TableRow>
              </TableHead>
            </Table>
          </TableContainer>
        ) : (
          <Box sx={{ p: 2 }}>
            <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
              Mail Preview
            </Typography>

            <iframe
              title="Reshare Mail Preview"
              srcDoc={previewHtml}
              style={{
                width: '100%',
                minHeight: '500px',
                border: 'none'
              }}
            />
          </Box>
        )}
      </DialogContent>

      <DialogActions>
        <Button
          onClick={handleReshare}
          variant="contained"
          color="primary"
          disabled={reshareLoading}
        >
          {reshareLoading ? 'Resharing...' : showPreview?.btn_text}
        </Button>

        <Button
          onClick={() =>
            setShowPreview({
              status: false,
              endorsementId: null
            })
          }
          variant="contained"
          color="error"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReshareEndorsementPreview;
